import React, { useState } from "react";
import { Link } from "react-router-dom";
import { gaConsentRequired, getConsent, setConsent } from "@/lib/analytics";

/**
 * Only appears if a cookie-setting analytics tool (GA4) is configured
 * AND the visitor hasn't already accepted or declined. Plausible sites
 * never show it because Plausible is cookieless.
 */
const CookieBanner = () => {
  const [dismissed, setDismissed] = useState(!gaConsentRequired || Boolean(getConsent()));
  if (dismissed) return null;

  const decide = (choice) => {
    setConsent(choice);
    setDismissed(true);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed inset-x-4 md:inset-x-auto md:right-6 md:left-auto md:max-w-md bottom-4 z-[100] bg-ink text-white rounded-2xl shadow-2xl border border-white/10 p-5"
    >
      <p className="font-mono text-xs font-extrabold uppercase tracking-widest text-primary mb-2">Cookies</p>
      <p className="text-sm text-white/80 leading-relaxed">
        We use a small number of analytics cookies to understand how the site is used and to make it better. You can accept, decline, or read our{" "}
        <Link to="/cookies" className="underline underline-offset-2 hover:text-primary">cookie notice</Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button
          onClick={() => decide("accepted")}
          data-testid="cookie-accept"
          className="font-sans text-sm font-bold bg-primary text-primary-foreground rounded-full px-5 py-2.5 hover:bg-white hover:text-ink transition-colors"
        >
          Accept
        </button>
        <button
          onClick={() => decide("declined")}
          data-testid="cookie-decline"
          className="font-sans text-sm font-bold border-2 border-white/25 text-white/80 rounded-full px-5 py-2.5 hover:border-white hover:text-white transition-colors"
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
